import { useEffect, useRef } from 'react';
import { useAppSelector } from 'redux/hooks';
import {
  areaMasterSelector,
  occupationMasterSelector,
} from '@doda/common/src/redux/features/master';
import { useIsomorphicLayoutEffect } from '@doda/common/src/hooks/useIsomorphicLayoutEffect';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import { SUBMIT } from '@doda/common/src/components/DesiredConditionsModal/logics/event';
import { MatchJobDialog } from 'components/MatchJobDialog';
import { measurePageViewDesiredConditionSetting } from '../logics/analytics';
import { useSetModal, useModalState } from './Layout';

export const DesiredCondModal = () => {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const areaMaster = useAppSelector(areaMasterSelector);
  const occupationMaster = useAppSelector(occupationMasterSelector);
  const isOpen = useModalState();
  const setModal = useSetModal();

  useEffect(() => {
    if (!dialogRef.current) return;
    if (isOpen) {
      dialogRef.current.showModal();
      measurePageViewDesiredConditionSetting();
    }
  }, [isOpen]);

  useIsomorphicLayoutEffect(() => {
    if (isOpen) document.body.classList.toggle('scroll-lock', true);
  }, [isOpen]);

  useEffect(() => {
    if (!dialogRef.current) return;
    // モーダルが閉じられた際の処理
    const handleClose = () => {
      setModal(false);
      // 希望条件が設定された(「希望条件を変更する」ボタンが押された)場合は画面URL(クエリパラメータを含まない)へ遷移
      if (dialogRef.current?.returnValue === SUBMIT)
        window.location.href = DODA_SITE_URL.matchJobList;
    };
    dialogRef.current.addEventListener('close', handleClose);
    const refClosure = dialogRef.current;
    // eslint-disable-next-line consistent-return
    return () => {
      refClosure.removeEventListener('close', handleClose);
    };
  }, [setModal]);

  return (
    <MatchJobDialog
      dialogReference={dialogRef}
      areas={areaMaster}
      jobTypes={occupationMaster}
    />
  );
};
